import { createSlice, configureStore } from "@reduxjs/toolkit";
import { selectIcon } from "../components/UI/selector";

const initialState = {
  is_email_verified: false,
  is_permanently_deleted: false,
  is_profile_public: false,
  has_skipped_membership_code: false,
  has_skipped_link_facebook: false,
  is_updated: false,
  name: "",
  first_name: "",
  last_name: "",
  dob: "",
  gender: "",
  email: null,
  is_welcome_email_sent: false,
  thumb: selectIcon("userDummy"),
  original: selectIcon("userDummy"),
  age: 0,
  description: null,
  user_id: null,
  total_activities_as_member: 0,
  total_calories_burnt: 0,
  participant_video_visibility: null,
  weight_unit: null,
  weight_value: null,
  height_unit: null,
  height_value: null,
  pendingGyms: [],
  approvedGyms: [],
  gyms: [],
  gymIds: [],
  currentStatus: "",
  sections: { sections: [], categories: [] },
  deletion_requested_at: null,
  notifications: null,
  firebaseToken: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profileData: initialState,
  },
  reducers: {
    updateProfileData(state, action) {
      state.profileData = { ...state.profileData, ...action.payload };
    },
    updatePendingGyms(state, action) {
      state.profileData.pendingGyms = {
        ...state.profileData.pendingGyms,
        ...action.payload,
      };
    },
    addPendingGyms(state, action) {
      state.profileData.pendingGyms = [
        ...state.profileData.pendingGyms,
        ...action.payload,
      ];
    },
    updateSections(state, action) {
      state.profileData.sections = { ...action.payload };
    },
    reset(state, action) {
      state.profileData = { ...initialState };
    },
  },
});

const store = configureStore({
  reducer: { profile: profileSlice.reducer },
});

export const profileActions = profileSlice.actions;

export default store;
